import { apiWithProject } from './greenetworkAPI';

const END_POINT = '/comments';

const getDeviceComments = (machineId) => apiWithProject.get(`${END_POINT}/device/${machineId}`);

const addNewComment = (machineId, commentInfo) => apiWithProject.post(`${END_POINT}/device/${machineId}`, {
    content: commentInfo.content,
    images: commentInfo.images,
})

const editComment = (commentInfo) => apiWithProject.put(`${END_POINT}/${commentInfo.id}`, {
    content: commentInfo.content,
})

const deleteComment = (commentId) => apiWithProject.delete(`${END_POINT}/${commentId}`);

const Comments = { addNewComment, getDeviceComments, editComment, deleteComment };

export default Comments;
